module.exports = __webpack_public_path__ + "static/media/edata.7552fcef.png";